import { useUserSettingsStore } from '@/stores/userSettingsStore.ts';
import { useAlertStore } from '@/stores/alertStore.ts';
import { useUserSettingsActions } from '@/actions/powerMarkets/userSettingsActions.ts';

const CHANNEL_NAME = 'user_settings_change';

let userSettingsChangeBroadcastChannel: BroadcastChannel | null = null;
const uniqueTabId = crypto.randomUUID();

export function subscribeToOtherTabUserSettingsChange (): void {
    if (typeof BroadcastChannel === 'undefined') return;
    userSettingsChangeBroadcastChannel = new BroadcastChannel(CHANNEL_NAME);
    userSettingsChangeBroadcastChannel.onmessage = (ev: MessageEvent<string>): void => {
        if (ev.data === uniqueTabId) return;
        const userSettingsStore = useUserSettingsStore();
        const tabUpdateValue = userSettingsStore.userSettings?.otherSettings?.data?.tabUpdateValue ?? 'none';
        switch (tabUpdateValue) {
            case 'warn':
            case 'warning': {
                const alertStore = useAlertStore();
                alertStore.setAccessDeniedModal(
                    'release',
                    'Your User Settings have been updated on another tab/window, we recommend that you refresh before making any changes on this screen to avoid clashes.<br />This message can be turned on/off in your User Settings.',
                );
                alertStore.setShowAccessDeniedModal(true);
                break;
            }
            case 'update': {
                const userSettingsActions = useUserSettingsActions();
                userSettingsActions.fetchUserSettings();
                break;
            }
            case 'none':
            default:
                break;
        }
    };
}

export function sendOtherTabUserSettingsChange (): void {
    if (typeof BroadcastChannel === 'undefined') return;
    if (!userSettingsChangeBroadcastChannel) {
        userSettingsChangeBroadcastChannel = new BroadcastChannel(CHANNEL_NAME);
    }
    userSettingsChangeBroadcastChannel.postMessage(uniqueTabId);
}
